import { LOCAL_STORAGE_KEYS } from '../../enums/localStorageKeys';
import { localStorageGetItem, localStorageSetItem } from './localStorageMethods';

let cachedAttendeeId: string | null = null;

export const setAttendeeId = (id: string): void => {
  cachedAttendeeId = id;
  localStorageSetItem(LOCAL_STORAGE_KEYS.ATTENDEE_ID, id);
};

export const getAttendeeId = (): string | null => {
  if (cachedAttendeeId) return cachedAttendeeId;
  const stored = localStorageGetItem(LOCAL_STORAGE_KEYS.ATTENDEE_ID);
  cachedAttendeeId = stored;
  return stored;
};

export const clearAttendeeId = (): void => {
  cachedAttendeeId = null;
  localStorage.removeItem(LOCAL_STORAGE_KEYS.ATTENDEE_ID);
};
